import { render, staticRenderFns } from "./pflanzenkrankheiten-rueckmledung.vue?vue&type=template&id=b58d275e&scoped=true&"
import script from "./pflanzenkrankheiten-rueckmledung.vue?vue&type=script&lang=js&"
export * from "./pflanzenkrankheiten-rueckmledung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58d275e",
  null
  
)

export default component.exports